import React, { useState } from 'react';
import cashReservesService from '../../services/cashReservesService';
import { hasManagementFeeReserve } from './helpers';

// ─── management-fee warning + toggle ──────────────────────────────────────────
// Shows account-level management-fee warning controls. Three states:
//   • account has a Management Fee reserve      -> nothing (requirement met)
//   • account has none, not waived              -> "Missing Mgmt Fee" badge + "Waive"
//   • account has none, waived (ignored)        -> "Ignore Mgmt Fee Req" badge + "Restore"
const MgmtFeeWarningToggle = ({ account, onChanged, compact = false }) => {
  const [working, setWorking] = useState(false);
  const [error, setError] = useState('');

  const waived = account.ignored;
  if (hasManagementFeeReserve(account) && !waived) return null;

  const handleClick = async () => {
    setWorking(true);
    setError('');
    try {
      if (waived) {
        await cashReservesService.removeIgnoredAccount(account.account_number);
      } else {
        await cashReservesService.addIgnoredAccount(account.account_number, {
          account_name: account.account_name || '',
        });
      }
      if (onChanged) onChanged();
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'Failed to update');
    } finally {
      setWorking(false);
    }
  };

  const badgeLabel = waived ? 'Ignore Mgmt Fee Req' : 'Missing Mgmt Fee';
  const badgeClass = waived ? 'bg-secondary' : 'bg-warning text-dark';
  const badgeIcon = waived ? 'bi-eye-slash' : 'bi-exclamation-triangle-fill';
  const actionLabel = waived ? 'Restore' : 'Waive';
  const actionIcon = working ? 'bi-hourglass-split' : waived ? 'bi-arrow-counterclockwise' : 'bi-slash-circle';
  const title = waived
    ? 'Management-fee requirement waived for this account - restore the warning'
    : 'This account has no Management Fee reserve - waive the requirement';

  return (
    <div className="d-flex align-items-center gap-2">
      {error && <span className="text-danger small">{error}</span>}
      {/* In the Accounts subtable the badge would repeat down the column, so
          only the action shows; its tooltip still explains the state. */}
      {!compact && (
        <span className={`badge ${badgeClass}`}>
          <i className={`bi ${badgeIcon} me-1`}></i>
          {badgeLabel}
        </span>
      )}
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary"
        onClick={handleClick}
        disabled={working}
        title={title}
      >
        <i className={`bi ${actionIcon} me-1`}></i>
        {working ? 'Saving…' : actionLabel}
      </button>
    </div>
  );
};

export default MgmtFeeWarningToggle;
